import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customerCategories = async () => axios.get(Routes.CUSTOMER_CATEGORIES);

export const useCustomerCategories = () =>
  useQuery({
    queryKey: [Keys.CUSTOMER_CATEGORIES_QRY],
    queryFn: customerCategories,
  });
